// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newsItem":"newsItem-3BY3YZtk","zz":"zz-3MLN98hY"};